import { gql } from '@apollo/client'

import HELP_CENTER_ARTICLES_FRAGMENT from 'src/components/sections/HelpCenterArticles/fragments'

export default gql`
  query Teams {
    faqs: helpCenterArticles(topicSlug: "teams") {
      ...HelpCenterArticlesComponent
    }
  }

  ${HELP_CENTER_ARTICLES_FRAGMENT}
`
